import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';

function SedTeleLinkPopup({ handleClose, appId }) {
  const [allData, setAllData] = useState(null);
  const [mode, setMode] = useState({});
  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/sendMeetLinkPopUp',
          {
            appointmentId: appId || '',
          }
        );

        if (response?.status === 200) {
          setAllData(response?.data);
          if (response?.data?.emailAvail === '1') {
            setMode({ check1: false, check2: true });
          }
          if (response?.data?.mobileAvail === '1') {
            setMode({ check1: true, check2: false });
          }
          if (
            response?.data?.emailAvail === '1' &&
            response?.data?.mobileAvail === '1'
          ) {
            setMode({ check1: true, check2: true });
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [appId]);

  const handleSendTeleLink = async (appId) => {
    try {
      const response = await post(
        'api/appointment/Appointment/generateMeetLink',
        {
          appointmentId: appId,
          sendViaMode: mode,
        }
      );

      if (response?.status === 200) {
        if (response?.data?.sts === 'success') {
          setUiMessage('suc', 'Link successfully generated.');
          handleClose();
        } else if (response?.data?.sts === 'error') {
          setUiMessage('err', response?.data?.message);
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setMode({ ...mode, [name]: checked });
  };

  return (
    <div className="modalBackground">
      <div className="vconf-pt-dtl-man-cntnr">
        <div className="vconf-pt-dtl-hdr">
          <span className="left">{`${allData?.patName}`}</span>
          <span className="left clear-left10">{`${allData?.patStr}`}</span>
          <span className="right red bold cursor" onClick={handleClose}>
            X
          </span>
        </div>
        <div className="vconf-pt-dtl-bdy ">
          <span className="left vconf-link-send">
            Please select one option to send the telehealth invite for{' '}
            <span id="meetTov">{`${allData?.tov}`}</span>
          </span>
          <span
            className="left width100 med-common-bg"
            style={{ paddingBottom: '8px' }}
          >
            <span className="left vconf-link-optn" style={{ display: 'flex' }}>
              <span className="left">
                <input
                  type="checkbox"
                  className="left"
                  id="sentMeetOption1"
                  name="check1"
                  checked={mode.check1 || false}
                  onChange={handleCheckboxChange}
                  disabled={!allData?.mobile}
                />
              </span>
              <span className="left clear-left10">
                Via Text:{' '}
                <span id="meetMobNo">
                  {allData?.mobile ? allData?.mobile : 'NA'}
                </span>
              </span>
            </span>
            <span className="left vconf-link-optn">
              <span className="left">
                <input
                  type="checkbox"
                  className="left"
                  id="sentMeetOption2"
                  name="check2"
                  checked={mode.check2 || false}
                  onChange={handleCheckboxChange}
                  disabled={!allData?.email}
                />
              </span>
              <span className="left clear-left10">
                Via Email:
                <span id="meetMobEmail">
                  {allData?.email ? allData?.email : 'NA'}
                </span>
              </span>
            </span>
          </span>
        </div>
        <div className="vconf-pt-dtl-ftr">
          <span
            className="right actn-yes right"
            type="button"
            onClick={() => handleSendTeleLink(appId)}
          >
            Send
          </span>
        </div>
      </div>
    </div>
  );
}

export default SedTeleLinkPopup;
